import { trackInteraction } from './trackInteraction';
import { getScrollPercent } from './analyticsHelpers';

const SCROLL_THRESHOLDS = [25, 50, 75, 90];
let firedThresholds = new Set<number>();
let scrollListener: (() => void) | null = null;

const getViewportType = (): 'desktop' | 'mobile' => {
  return window.innerWidth >= 768 ? 'desktop' : 'mobile';
};

const handleScroll = (): void => {
  const percent = getScrollPercent();

  for (const threshold of SCROLL_THRESHOLDS) {
    if (percent >= threshold && !firedThresholds.has(threshold)) {
      firedThresholds.add(threshold);
      trackInteraction(
        `scroll-${threshold}pct-${getViewportType()}`,
        'page',
        'scroll_milestone',
      );
    }
  }
};

export const initScrollMilestoneTracking = (): void => {
  if (typeof window === 'undefined') return;

  if (scrollListener) {
    window.removeEventListener('scroll', scrollListener);
  }

  scrollListener = handleScroll;
  window.addEventListener('scroll', scrollListener, { passive: true });
};

export const resetScrollMilestones = (): void => {
  firedThresholds = new Set<number>();
};
